import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectAccessToken, setCredentials } from "store/slices/credentials";
import { setSpreadsheet } from "store/slices/spreadsheet";
import { ActionButton, Flex, Grid, Icon, Text } from "@adobe/react-spectrum";

import step1 from "./images/1.png";
import step2 from "./images/2.png";
import step3 from "./images/3.png";
import google from "./images/google.svg";

export const Login = () => {
  const dispatch = useDispatch();
  const accessToken = useSelector(selectAccessToken);
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => dispatch(setCredentials(codeResponse)),
    onError: (error) => console.log("Login Failed:", error),
    scope: "https://www.googleapis.com/auth/spreadsheets.readonly",
    redirect_uri:
      process.env.NODE_ENV === "development"
        ? undefined
        : "https://bob.richiepreece.com",
  });

  useEffect(() => {
    if (accessToken) {
      axios
        .get(
          "https://sheets.googleapis.com/v4/spreadsheets/1smFPunWAknv47m6hMlD8N4HuBPVNGqJkW68ZYYwIOBc",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: "application/json",
            },
          }
        )
        .then((data) => {
          dispatch(setSpreadsheet(data.data));
          navigate("/quizzer");
        })
        .catch((err) => console.log(err));
    }
  }, [accessToken]);

  return (
    <Grid
      areas={[
        "step0 step1 step2 step3 step4",
        "blank1 instructions instructions instructions blank2",
        "button button button button button",
      ]}
      columns={["1fr 1fr 1fr 1fr 1fr"]}
      gap="size-600"
      marginTop="size-800"
    >
      <Flex gridArea="step1" maxWidth="100%" justifyContent="space-around">
        <img
          src={step1}
          alt="Step 1 instructions"
          style={{ maxWidth: "100%", objectFit: "contain" }}
        />
      </Flex>
      <Flex gridArea="step2" maxWidth="100%" justifyContent="space-around">
        <img
          src={step2}
          alt="Step 2 instructions"
          style={{ maxWidth: "100%", objectFit: "contain" }}
        />
      </Flex>
      <Flex gridArea="step3" maxWidth="100%" justifyContent="space-around">
        <img
          src={step3}
          alt="Step 3 instructions"
          style={{ maxWidth: "100%", objectFit: "contain" }}
        />
      </Flex>

      <Flex gridArea="instructions" justifyContent="center">
        <Text>
          If you run into these screens, please click on the red highlighted
          areas
        </Text>
      </Flex>

      <Flex direction="row" justifyContent="space-around" gridArea="button">
        <ActionButton onPress={login}>
          <Icon>
            <img src={google} alt="Google logo" />
          </Icon>
          <Text>Sign in with Google</Text>
        </ActionButton>
        {/* <button onClick={login}>Sign in with Google 🚀 </button> */}
      </Flex>
    </Grid>
  );
};
